import React, { useMemo } from 'react';
import { useCarrierQuery } from 'src/services/carrier';
import { useTranslation } from 'react-i18next';
import Select, { Option } from '../Select/Select';
import { findCarrierOption, mapCarriersToOptions } from './helpers/carrierHelpers';

type CarrierSelectProps = {
  defaultCarrier?: number;
  onChange: (carrierId: number | undefined) => void;
  disabled?: boolean;
  className?: string;
};

const CarrierSelect: React.FC<CarrierSelectProps> = ({ defaultCarrier, onChange, disabled, className }) => {
  const {
    data: carriers,
    isLoading,
    isFetching,
  } = useCarrierQuery({
    page: 1,
    size: 100,
  });

  const { t } = useTranslation();

  const carrierOptions: Option[] = useMemo(() => {
    const activeCarriers = carriers?.items?.filter(c => c.active);
    return mapCarriersToOptions(activeCarriers);
  }, [carriers]);

  const selectedCarrier = useMemo(() => {
    return findCarrierOption(carrierOptions, defaultCarrier);
  }, [carrierOptions, defaultCarrier]);

  return (
    !isFetching && (
      <Select
        options={carrierOptions}
        defaultValue={selectedCarrier}
        onChange={option => {
          if (option) {
            const carrierId = parseInt(option.value, 10);
            onChange(Number.isNaN(carrierId) ? undefined : carrierId);
          } else {
            onChange(undefined);
          }
        }}
        placeholder={t('outbound.select_carrier')}
        disabled={disabled || isLoading}
        className={className}
        isClearable
        isSearchable
      />
    )
  );
};

export default CarrierSelect;
